import { PolicyInsight } from '../../../../types/policies';
import { apiPost } from '../../../../api';
import { useMutation } from '@tanstack/react-query';

interface Response {
    insightId: PolicyInsight['policyId'];
}

interface ErrorResponse {
    error: string;
}

type UseResolveInsightParams = {
    onSuccess?: (response: Response) => void;
    onError?: (errorResponse: ErrorResponse) => void;
};

const resolveInsight = (insightId: PolicyInsight['id']) => {
    return apiPost<never, Response>(`/policies/insights/${insightId}/resolve`);
};

export const useResolveInsight = ({ onSuccess, onError }: UseResolveInsightParams) => {
    return useMutation({
        mutationFn: resolveInsight,
        onSuccess,
        onError
    });
};
